import { config } from "../../config"
import { zip } from "../../helpers/utils"

export const commits = {
  readAll: ({ token, from = 1, limit = 1000 }) => {
    const base = config.apiUrl + `/commits`,
      opt = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }

    const params = zip([from, limit], ["f", "l"])

    let query = params
      .filter((param) => param[0] !== null && param[0] !== "")
      .map((param) => `&${param[1]}=${param[0]}`)
      .join("")

    if (query.length) query = "?" + query.substr(1)

    return { url: base + query, opt }
  },
}
